import { render, staticRenderFns } from "./applications-stats.vue?vue&type=template&id=25c7c956&"
import script from "./applications-stats.vue?vue&type=script&lang=js&"
export * from "./applications-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports